export class PatientEdiaryConfig {
  public id: string;
  public timezone: string;
  public patientTrialId: string;
  public created: Date;
  public startDate: Date;
  public endDate: Date;
  public remindersEnabled: boolean;
  public emailRemindersEnabled: boolean;
  public reminderTimeMinutes: number;
  public reminderTimeMinutesUtc: number;
  public mandatoryNotification: boolean;
  public intraDayReminderTimes: number[] = [];
}
